import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy, OrderStatus } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.scss']
})
export class WarningPopupComponent implements OnInit {
  isLoading: boolean = false;
  tenant: any = localStorage.getItem('tenant')
  payload: { orders: 'sale' | 'processed', NotifyUsers: boolean, PaymentOrders: Array<any>, NotifyUsersBy: Array<number> } = {
    orders: this.getOrderType,
    NotifyUsers: true,
    PaymentOrders: [],
    NotifyUsersBy: []
  }
  OrderStatus = OrderStatus;
  form!: FormGroup;
  constructor(public dialogRef: MatDialogRef<WarningPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any,
    private shippingService: ShippingService,
    public krollService: KRollService,
    public router: Router,
    public toast: ToastrService,
    public validationMessagesService: ValidationMessagesService,
    public fb: FormBuilder,
    private formService: FormService
  ) {
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.payload.orders = this.getOrderType;
      }
    });
    this.initializeNotifyForm();
  }
  ngAfterViewInit() {
    this.payload.orders = this.getOrderType;
  }

  get getOrderType() {
    if (!this.router || !this.router.url) {
      return 'sale';
    }

    if (this.router.url.includes('/portal/shipping')) {
      return 'sale';
    } else if (this.router.url.includes('/portal/orders')) {
      return 'processed';
    }

    return 'sale';
  }



  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addNotifyControl();
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }

  onProceedClick() {
    if (this.form.valid) {
      this.payload.PaymentOrders = [{
        "SalesOrderID": this.props.item.ID,
        "OrderID": this.props.item.OrderID,
        "UserID": this.props.item.UserID,
        "Amount": this.props.item.PaymentDue,
        "IsAutoPay": false,
        "PayWith": "other"
      }]
      this.payload.NotifyUsers = this.form.value.NotifyUsers;
      if (this.form.value.NotifyUsersBy?.length > 0) {
        this.payload.NotifyUsersBy = this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id);
      }

      this.isLoading = true;
      this.krollService.sales_order_process_payment(this.payload).subscribe(res => {
        if (res.body.success) {
          this.props.item.PaymentDue = 0;
          this.props.item.SalesOrderStatus = this.payload.orders == 'processed' ? OrderStatus.Paid : OrderStatus.PaidAndReadyToShip;
          this.props.item.PayWith = "other";
          this.toast.success(res.body.message[0]);
          this.isLoading = false;
          this.dialogRef.close();
        }
        else {
          this.isLoading = false;
          this.toast.error(res.body.message[0]);
        }
      }, err => {
        this.isLoading = false;
        this.toast.error(err.message[0]);
      });
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
  initializeNotifyForm() {
    let { NotifyUsers } = this.payload;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
    });
    if (NotifyUsers) {
      this.addNotifyControl();
    }
  }
  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(this.fb.group({
        id: new FormControl(x.id),
        value: new FormControl(x.value),
        isChecked: new FormControl(x.isChecked),
        disable: new FormControl(this.tenant == 'sl' ? true : false)
      }));
    });
  }
}

